import BaseResource from './BaseResource';

export default class CommonEnumsResource extends BaseResource {
  constructor() {
    super({ url: '/api/enums' });
  }

  list(name = '') {
    return super
      .get({ url: `${this.url}/${name}` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
